import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators, InventoryChangeType, State } from '../../state';
import NumberEntryView from '../NumberEntryView/NumberEntryView';
import './UpdateInventoryView.css';

interface UpdateInventoryViewProps {
  valueToUpdate: (value: number) => void
  didComplete: () => void
}

const UpdateInventoryView: FC<UpdateInventoryViewProps> = ({valueToUpdate, didComplete}: UpdateInventoryViewProps) => {

  const { inventoryState } = useSelector((state: State) => state)
  const dispatch = useDispatch()
  const { updateInventoryTypeState } = bindActionCreators(actionCreators, dispatch)

  const toggleInventoryChangeType = () => {
    var current = inventoryState.changeType
    if (current === InventoryChangeType.Adjust) {
      current = InventoryChangeType.Restock
    } else {
      current = InventoryChangeType.Adjust
    }
    updateInventoryTypeState({type: current})
  }

  return (
    <div className="UpdateInventoryView">
      <div className="tab-header-container">
        <div className="gap" />
        <div className={`tab left${inventoryState.changeType === InventoryChangeType.Adjust ? ' selected' : ''}`} onClick={toggleInventoryChangeType} >ADJUST INVENTORY</div>
        <div className="gap" style={{flex: '0.5'}} />
        <div className={`tab right${inventoryState.changeType === InventoryChangeType.Restock ? ' selected' : ''}`} onClick={toggleInventoryChangeType} >RESTOCK</div>
        <div className="gap" />
      </div>
      <div className="tab-header-bottom" />
      <div className="entry-container">
        <NumberEntryView 
          valueToUpdate={valueToUpdate} 
          onReturnClick={didComplete}
          maxEntry={inventoryState.changeType === InventoryChangeType.Adjust ? 36 : 36 - inventoryState.inventory}
        />
      </div>
    </div>
  )
};

export default UpdateInventoryView;
